import { render, staticRenderFns } from "./chooseGift.vue?vue&type=template&id=16b508fc&"
import script from "./chooseGift.vue?vue&type=script&lang=js&"
export * from "./chooseGift.vue?vue&type=script&lang=js&"
import style0 from "./chooseGift.vue?vue&type=style&index=0&id=16b508fc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports